export default __webpack_public_path__ + "static/media/brand-hort-colour.3ba8858c.svg";